/**
 * @deprecated use data-some-attribute
 */
export function when(fn) {
  return (props) => (fn(props) ? '&' : '.__void__');
}
